import { tv } from 'tailwind-variants';

export const CruiseStartButton = ({ onClick }: { onClick: () => void }) => {
	const ButtonVariants = tv({
		base: [
			'w-full h-full rounded-3xl text-5xl font-bold transition shadow-xl',
			'bg-blue-600 hover:bg-blue-700 active:bg-blue-700',
			'disabled: bg-gray-800',
		],
	});

	return (
		<button onClick={onClick} className={ButtonVariants()}>
			자율주행 모드 진입
		</button>
	);
};
